import React from "react";

const Image = ({ filename, alt = "", ext, renditions = [], ...rest }) => {
  const getRenditionSrc = (filename, ext, rendition) => {
    return `${
      require(`../../../assets/images/${filename}@${rendition}.${ext}`).default
    } ${rendition}`;
  };

  const getSrcSet = () => {
    let renditionsSrc = "";
    if (renditions.length > 0) {
      renditionsSrc = renditions.map((rendition) =>
        getRenditionSrc(filename, ext, rendition)
      );
    } else {
      renditionsSrc = `${
        require(`../../../assets/images/${filename}.${ext}`).default
      }`;
    }
    return renditionsSrc;
  };
  var getImage = () => {
    try {
      return (
        <img
          {...rest}
          src={require(`../../../assets/images/${filename}.${ext}`).default}
          srcSet={getSrcSet().toString()}
          alt={alt}
        />
      );
    } catch (e) {
      //console.log(`${filename} "Image not found \n Error:" ${e}`)
      return null;
    }
  };
  return getImage();
};

export default Image;
